import React from 'react';
import { SpinnerIcon, CheckCircleIcon, InformationCircleIcon } from '../../Icons';

interface VisitStatusProps {
  status: 'loading' | 'success' | 'error' | 'fetching_config';
  errorData?: { message: string; requestId: string } | null;
  propertyCode?: string;
  onClose: () => void;
  onRetry: () => void;
}

export const VisitStatus: React.FC<VisitStatusProps> = ({ status, errorData, propertyCode, onClose, onRetry }) => {
  if (status === 'fetching_config' || status === 'loading') {
    return (
      <div className="text-center p-20 flex-grow flex flex-col justify-center items-center">
        <SpinnerIcon className="w-12 h-12 text-sky-600 mb-4" />
        <p className="text-gray-500 font-bold uppercase text-[10px] tracking-widest">
          {status === 'loading' ? 'Enviando...' : 'Cargando disponibilidad...'}
        </p>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div className="text-center p-12 animate-fade-in flex-grow flex flex-col justify-center items-center">
        <CheckCircleIcon className="w-20 h-20 text-green-500 mb-6" />
        <h3 className="text-xl font-black text-gray-800 uppercase mb-4">Solicitud Enviada</h3>
        
        <div className="bg-sky-50 border border-sky-100 p-6 rounded-2xl max-w-md">
          <p className="text-xs text-sky-900 leading-relaxed font-medium">
            En los próximos <strong>2 minutos</strong> deberías recibir un correo por parte de 
            <span className="block font-black my-1 text-sky-700">'info.ciencuadras.com@viazohocrm.com'</span> 
            notificando tu visita, de no ser así por favor comunícate con tu asesor para revisar el inconveniente.
          </p>
        </div>

        <button onClick={onClose} className="mt-8 px-12 py-3 bg-[#00234F] text-white rounded-xl font-black uppercase text-xs tracking-widest">
          Cerrar
        </button>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="text-center p-10 animate-fade-in flex-grow flex flex-col justify-center items-center">
        <InformationCircleIcon className="w-16 h-16 text-red-500 mb-4" />
        <h3 className="text-lg font-black text-gray-800 uppercase">Error al procesar</h3>
        {errorData && (
          <div className="mt-4 text-sm text-gray-600 space-y-2">
            <p className="font-bold">{errorData.message}</p>
            <p className="text-[10px] text-gray-400">ID de solicitud: {errorData.requestId}</p>
          </div>
        )}
        
        <div className="mt-8 p-4 bg-red-50 rounded-2xl border border-red-100 max-w-md">
          <p className="text-xs text-red-800 font-bold mb-3">
            ¿Estás teniendo problemas para registrar tu visita? créala aquí:
          </p>
          <a 
            href={`https://script.google.com/a/macros/serviciosbolivar.com/s/AKfycbxRMpa0F1uK4iIwP-TLSQdPmdovWirztnhzKukt3PRHq39GrXelS9qOFqxzDLUEEW_j/exec?codigo=${propertyCode || ''}`} 
            target="_blank" 
            rel="noopener noreferrer"
            onClick={onClose}
            className="inline-block px-6 py-2 bg-red-600 text-white rounded-lg font-bold uppercase text-[10px] tracking-widest hover:bg-red-700 transition-colors"
          >
            Formulario de Contingencia
          </a>
        </div>
        
        <button onClick={onRetry} className="mt-8 text-xs font-bold text-gray-500 uppercase hover:underline">
          Volver al formulario
        </button>
      </div>
    );
  }

  return null;
};
